import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Header({ searchQuery, setSearchQuery, onProfile })
 {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <header className="main-header">
      <div className="header-row">
        {/* LEFT: LOGO */}
        <div
          className={`brand-wrap ${
            animate ? "brand-animate" : ""
          }`}
          onClick={() => navigate("/")}
        >
          <span className="play-icon">▶</span>
          <h1 className="brand">
            watchit<span>-Now</span>
          </h1>
          
        </div>

        {/* CENTER: SEARCH */}
        <div className="header-search">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            className="search-input"
            placeholder="Search movies, actors, genres…"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* RIGHT: PROFILE */}
        <button
          className="profile-btn glow"
          onClick={onProfile}
          aria-label="Profile"
        >
          <span className="profile-avatar">👤</span>
        </button>
      </div>
    </header>
  );
}

export default Header;
